import React, { useState, createElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, UserCheck, Home, Video, MessageCircle, CreditCard, ChevronRight } from 'lucide-react';
const slides = [{
  id: 1,
  title: 'Find verified professionals near you',
  description: 'Connect with top-rated doctors, nurses, and caregivers in your area instantly.',
  icons: [MapPin, UserCheck]
}, {
  id: 2,
  title: 'Care on your own terms',
  description: 'Book home visits, clinic appointments, or virtual video consultations with ease.',
  icons: [Home, Video]
}, {
  id: 3,
  title: 'All your health needs in one place',
  description: "Chat securely, pay seamlessly, and manage your entire family's health records.",
  icons: [MessageCircle, CreditCard]
}];
export function OnboardingScreen() {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const handleNext = () => {
    if (currentSlide === slides.length - 1) {
      navigate('/signup');
    } else {
      setCurrentSlide(prev => prev + 1);
    }
  };
  return <div className="min-h-screen bg-ui-bg flex flex-col p-6" data-id="element-1077">
      <div className="flex justify-end pt-4" data-id="element-1078">
        <button onClick={() => navigate('/signup')} className="text-text-secondary font-medium px-4 py-2" data-id="element-1079">
          Skip
        </button>
      </div>

      <div className="flex-1 flex flex-col justify-center relative" data-id="element-1080">
        <AnimatePresence mode="wait" data-id="element-1081">
          <motion.div key={currentSlide} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -20
        }} transition={{
          duration: 0.3
        }} className="flex flex-col items-center text-center" data-id="element-1082">
            <div className="w-64 h-64 bg-brand-light rounded-full flex items-center justify-center mb-10 relative" data-id="element-1083">
              {createElement(slides[currentSlide].icons[0], {
              size: 64,
              className: 'text-brand-primary absolute -ml-12 -mt-12'
            })}
              {createElement(slides[currentSlide].icons[1], {
              size: 56,
              className: 'text-brand-dark absolute ml-16 mt-16'
            })}
              <div className="absolute inset-0 bg-brand-primary/5 rounded-full animate-pulse" data-id="element-1084"></div>
            </div>

            <h2 className="text-2xl font-bold text-text-main mb-4 px-4" data-id="element-1085">
              {slides[currentSlide].title}
            </h2>
            <p className="text-text-secondary text-base px-6 leading-relaxed" data-id="element-1086">
              {slides[currentSlide].description}
            </p>
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="pb-8 pt-4" data-id="element-1087">
        <div className="flex justify-center space-x-2 mb-8" data-id="element-1088">
          {slides.map((_, idx) => <div key={idx} className={`h-2 rounded-full transition-all duration-300 ${idx === currentSlide ? 'w-8 bg-brand-primary' : 'w-2 bg-ui-border'}`} data-id="element-1089" />)}
        </div>

        <button onClick={handleNext} className="w-full bg-brand-primary text-white font-semibold text-lg py-4 rounded-xl shadow-lg active:scale-[0.98] transition-transform flex items-center justify-center" data-id="element-1090">
          {currentSlide === slides.length - 1 ? 'Create Account' : 'Next'}
          {currentSlide !== slides.length - 1 && <ChevronRight className="ml-2" size={20} data-id="element-1091" />}
        </button>
      </div>
    </div>;
}